
export default {
  props: {
    pagination: { type: Object, required: true },
  },

  computed: {
    pageIndices() {
      const currentPage = this.pagination.currentPage;
      const totalPages = this.pagination.totalPages;
      let start = currentPage - 2;
      let end = currentPage + 2;

      let indices =
        currentPage > 4
          ? ["« Previous", 1, "..."]
          : currentPage > 3
          ? ["« Previous", 1]
          : currentPage > 1
          ? ["« Previous"]
          : [];

      for (
        let i = start <= 0 ? 1 : start;
        i <= (end > totalPages ? totalPages : end);
        i++
      ) {
        indices.push(i);
      }

      indices =
        totalPages - currentPage > 3
          ? [...indices, "...", totalPages, "Next »"]
          : totalPages - currentPage > 2
          ? [...indices, totalPages, "Next »"]
          : totalPages - currentPage > 0
          ? [...indices, "Next »"]
          : indices;

      return indices;
    },
  },

  methods: {
    buildURL(page) {
      return this.$router.resolve({
        query: {
          ...this.$route.query,
          page: `${page}`.includes("Previous")
            ? this.pagination.previousPage
            : `${page}`.includes("Next")
            ? this.pagination.nextPage
            : page,
        },
      }).href;
    },
  },
};
